(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-editorial-v6"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ====================================================================
    // HELPERS PUROS (candidatos a asset compartido product-helpers.js)
    // ====================================================================
    function escapeHtmlV6(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatPriceV6(cents) {
      if (typeof cents !== 'number') return '';
      var locale = (document.documentElement.lang || 'es-ES');
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    // ====================================================================
    // ESTADO LOCAL: mapa de observers por sección, para poder limpiar
    // ====================================================================
    var observersBySection = new WeakMap();

    // ====================================================================
    // LÓGICA DE TARJETA (autocontenida, candidata a snippet)
    // ====================================================================
    function initCardV6(cardEl) {
      // No hace falta hidratar nada interactivo en la tarjeta editorial.
      // Si en el futuro se añade quick-view o ATC, va aquí.
      return cardEl;
    }

    // ====================================================================
    // LÓGICA DE LAYOUT (específica de esta sección)
    // ====================================================================
    function initV6(root) {
      if (!root || root.dataset.sn6Init === '1') return;
      root.dataset.sn6Init = '1';

      var card = root.querySelector('[data-sn6-card]');
      if (card) initCardV6(card);

      // Fade-in en viewport, respetando prefers-reduced-motion.
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || !('IntersectionObserver' in window)) {
        if (card) card.classList.add('sn6-in-view');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sn6-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

      if (card) observer.observe(card);
      observersBySection.set(root, observer);
    }

    // ====================================================================
    // CLEANUP (al desmontar la sección en el customizer o navegación)
    // ====================================================================
    function cleanupV6(root) {
      if (!root) return;
      var obs = observersBySection.get(root);
      if (obs) {
        obs.disconnect();
        observersBySection.delete(root);
      }
      delete root.dataset.sn6Init;
    }

    // ====================================================================
    // BOOTSTRAP
    // ====================================================================
    function bootstrapV6(scope) {
      var ctx = scope || document;
      var roots = ctx.querySelectorAll('[data-sn6-section]');
      roots.forEach(initV6);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bootstrapV6(); });
    } else {
      bootstrapV6();
    }

    // ====================================================================
    // SHOPIFY CUSTOMIZER LIFECYCLE
    // ====================================================================
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-sn6-section]');
      if (root) initV6(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-sn6-section]');
      if (root) cleanupV6(root);
    });

    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target.querySelector('[data-sn6-section]');
      if (root) root.setAttribute('data-sn6-selected', 'true');
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target.querySelector('[data-sn6-section]');
      if (root) root.removeAttribute('data-sn6-selected');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var roots = document.querySelectorAll('[data-sn2-section]');
    if (!roots || roots.length === 0) return;

    roots.forEach(function (root) {
      if (root.dataset.sn2Initialized === 'true') return;
      root.dataset.sn2Initialized = 'true';

      var toast = root.querySelector('[data-sn2-toast]');
      var addButtons = root.querySelectorAll('[data-sn2-add]');
      var toastTimer = null;

      function sn2ShowToast(msg, isError) {
        if (!toast) return;
        toast.textContent = msg;
        toast.setAttribute('data-visible', 'true');
        toast.style.background = isError ? '#8a1c1c' : '#1a140f';
        if (toastTimer) clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toast.setAttribute('data-visible', 'false'); }, 2400);
      }

      function sn2DispatchCartRefresh(cartData) {
        var evts = ['cart:refresh', 'cart:updated', 'cart:add', 'cart:change'];
        evts.forEach(function (name) {
          // El header (sections/header.liquid) lee detail.cart.item_count
          try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cartData || {} } })); } catch (e) {}
        });
        var drawer = document.querySelector('cart-drawer');
        var zhAtcActive = window.ZHAtc && window.ZHAtc.enabled;
        if (!zhAtcActive && drawer && typeof drawer.open === 'function') drawer.open();
        var bubble = document.querySelector('cart-icon-bubble');
        if (bubble && cartData && typeof cartData.item_count !== 'undefined') {
          try { if (typeof bubble.renderContents === 'function') bubble.renderContents(); } catch (e) {}
        }
      }

      function sn2AddToCart(btn) {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var label = btn.querySelector('.sn2-card__add-label');
        var original = label ? label.textContent : '';

        btn.setAttribute('data-loading', 'true');
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw new Error(err && err.description ? err.description : 'Error al añadir'); }); }
            return res.json();
          })
          .then(function (added) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cartData) { return { added: added, cart: cartData }; });
          })
          .then(function (result) {
            var cartData = result.cart;
            btn.removeAttribute('data-loading');
            btn.removeAttribute('aria-busy');
            btn.setAttribute('data-success', 'true');
            if (label) label.textContent = 'Añadido ✓';
            // Con la ventana «Añadido a la cesta» activa, no se muestra también el aviso de la sección
            if (window.ZHAtc && window.ZHAtc.enabled) {
              document.dispatchEvent(new CustomEvent('zh:cart-added', {
                detail: { item: result.added, cart: cartData, variantId: variantId, quantity: 1 }
              }));
            } else {
              sn2ShowToast('Producto añadido al carrito');
            }
            sn2DispatchCartRefresh(cartData);
            setTimeout(function () { btn.removeAttribute('data-success'); if (label) label.textContent = original; }, 1800);
          })
          .catch(function (err) {
            btn.removeAttribute('data-loading');
            btn.removeAttribute('aria-busy');
            btn.setAttribute('data-error', 'true');
            if (label) label.textContent = 'Error';
            sn2ShowToast(err && err.message ? err.message : 'No se pudo añadir el producto', true);
            setTimeout(function () { btn.removeAttribute('data-error'); if (label) label.textContent = original; }, 2200);
          });
      }

      addButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          sn2AddToCart(btn);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-v4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var instances = new WeakMap();

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function initV4(root) {
      if (!root || instances.has(root)) return;

      var perViewDesktop = parseInt(root.dataset.desktopPerView, 10) || 3;
      var perViewMobile = parseInt(root.dataset.mobilePerView, 10) || 1;

      root.style.setProperty('--sn4-pv-desktop', perViewDesktop);
      root.style.setProperty('--sn4-pv-tablet', Math.max(1, perViewDesktop - 1));
      root.style.setProperty('--sn4-pv-mobile', perViewMobile);

      var viewport = root.querySelector('.sn4-viewport');
      var track = root.querySelector('.sn4-track');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.sn4-slide')) : [];
      var prevBtn = root.querySelector('.sn4-nav-prev');
      var nextBtn = root.querySelector('.sn4-nav-next');
      var counterRange = root.querySelector('.sn4-counter-range');
      var counterTotal = root.querySelector('.sn4-counter-total');
      var liveRegion = root.querySelector('.sn4-viewport');
      var feedback = root.querySelector('.sn4-feedback');
      var progressEl = root.querySelector('.sn4-progress');
      var thumbEl = root.querySelector('.sn4-progress-thumb');

      if (!viewport || !track || slides.length === 0) {
        instances.set(root, { destroy: function () {} });
        return;
      }

      var state = {
        currentIndex: 0,
        perView: isMobile() ? perViewMobile : perViewDesktop,
        total: slides.length
      };

      function getMaxIndex() { return Math.max(0, state.total - state.perView); }
      function getSlideWidth() { return slides[0] ? slides[0].getBoundingClientRect().width : 0; }

      function getGap() {
        if (!track) return 0;
        var cs = window.getComputedStyle(track);
        var g = parseFloat(cs.columnGap || cs.gap || '0');
        return isNaN(g) ? 0 : g;
      }

      function getStep() { return getSlideWidth() + getGap(); }

      function updateCounter() {
        var start = state.currentIndex + 1;
        var end = Math.min(state.currentIndex + state.perView, state.total);
        if (counterRange) counterRange.textContent = start + ' – ' + end;
        if (counterTotal) counterTotal.textContent = state.total;
        if (liveRegion) liveRegion.setAttribute('data-live', 'slide ' + start + ' to ' + end + ' of ' + state.total);
      }

      function updateButtons() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = state.currentIndex <= 0;
        nextBtn.disabled = state.currentIndex >= getMaxIndex();
      }

      function updateProgress(progress) {
        if (!progressEl || !thumbEl) return;

        if (state.total <= state.perView) {
          progressEl.setAttribute('data-static', 'true');
          return;
        }
        progressEl.removeAttribute('data-static');

        var widthPct = (state.perView / state.total) * 100;
        var maxIdx = getMaxIndex();
        var p = (typeof progress === 'number')
          ? Math.max(0, Math.min(1, progress))
          : (maxIdx === 0 ? 0 : state.currentIndex / maxIdx);

        widthPct = Math.max(widthPct, 10);
        var leftPct = p * (100 - widthPct);

        thumbEl.style.width = widthPct + '%';
        thumbEl.style.left = leftPct + '%';
      }

      function applyTransform() {
        if (isMobile()) {
          track.style.transform = '';
          if (viewport.scrollTo) {
            var firstSlide = slides[state.currentIndex];
            if (firstSlide) {
              viewport.scrollTo({ left: firstSlide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            }
          }
        } else {
          var offset = state.currentIndex * getStep();
          track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
        }
      }

      function goTo(index) {
        state.currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        applyTransform();
        updateCounter();
        updateButtons();
        updateProgress();
      }

      function next() { goTo(state.currentIndex + 1); }
      function prev() { goTo(state.currentIndex - 1); }

      function onPrevClick(e) { e.preventDefault(); prev(); }
      function onNextClick(e) { e.preventDefault(); next(); }

      if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
      if (nextBtn) nextBtn.addEventListener('click', onNextClick);

      function onKeydown(e) {
        if (!root.contains(document.activeElement)) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
        else if (e.key === 'End') { e.preventDefault(); goTo(getMaxIndex()); }
      }
      root.addEventListener('keydown', onKeydown);

      var resizeRaf = null;
      function onResize() {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(function () {
          var newPerView = isMobile() ? perViewMobile : perViewDesktop;
          if (newPerView !== state.perView) { state.perView = newPerView; }
          state.currentIndex = Math.min(state.currentIndex, getMaxIndex());
          applyTransform();
          updateCounter();
          updateButtons();
          updateProgress();
        });
      }
      window.addEventListener('resize', onResize, { passive: true });

      var scrollRaf = null;
      var scrollEndTimer = null;
      function onScroll() {
        if (!isMobile()) return;
        if (progressEl) progressEl.setAttribute('data-dragging', 'true');

        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          var scrollLeft = viewport.scrollLeft;
          var step = getStep();
          if (step <= 0) return;

          var maxScroll = viewport.scrollWidth - viewport.clientWidth;
          var progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          updateProgress(progress);

          var newIndex = Math.round(scrollLeft / step);
          newIndex = Math.max(0, Math.min(newIndex, getMaxIndex()));
          if (newIndex !== state.currentIndex) {
            state.currentIndex = newIndex;
            updateCounter();
            updateButtons();
          }
        });

        if (scrollEndTimer) clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(function () {
          if (progressEl) progressEl.removeAttribute('data-dragging');
        }, 120);
      }
      viewport.addEventListener('scroll', onScroll, { passive: true });

      /* ===== REPRODUCCIÓN AUTOMÁTICA ===== */
      var autoplayEnabled = root.dataset.autoplay === 'true';
      var autoplayMs = (parseFloat(root.dataset.autoplayInterval) || 5) * 1000;
      var autoplayTimer = null;
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function autoplayStep() {
        if (getMaxIndex() <= 0) return;
        if (state.currentIndex >= getMaxIndex()) { goTo(0); } else { next(); }
      }
      function startAutoplay() {
        stopAutoplay();
        if (!autoplayEnabled || prefersReduced || getMaxIndex() <= 0) return;
        autoplayTimer = setInterval(autoplayStep, autoplayMs);
      }
      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      function onVisibility() { if (document.hidden) { stopAutoplay(); } else { startAutoplay(); } }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
      root.addEventListener('touchstart', stopAutoplay, { passive: true });
      document.addEventListener('visibilitychange', onVisibility);

      /* ===== ARRASTRE CON EL RATÓN (escritorio) ===== */
      var dragActive = false, dragStartX = 0, dragStartOffset = 0, draggedFar = false;

      function currentOffset() { return -state.currentIndex * getStep(); }

      function onPointerDown(e) {
        if (isMobile()) return;                         // en móvil manda el scroll nativo
        if (e.button !== undefined && e.button !== 0) return;
        dragActive = true; draggedFar = false;
        dragStartX = e.clientX;
        dragStartOffset = currentOffset();
        track.style.transition = 'none';
        track.classList.add('sn4-dragging');
        stopAutoplay();
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      }
      function onPointerMove(e) {
        if (!dragActive) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 5) draggedFar = true;
        var step = getStep();
        var maxOffset = 0;
        var minOffset = -getMaxIndex() * step;
        var pos = dragStartOffset + dx;
        if (pos > maxOffset) { pos = maxOffset + (pos - maxOffset) * 0.35; }        // resistencia en el extremo
        if (pos < minOffset) { pos = minOffset + (pos - minOffset) * 0.35; }
        track.style.transform = 'translate3d(' + pos + 'px, 0, 0)';
      }
      function onPointerUp(e) {
        if (!dragActive) return;
        dragActive = false;
        track.classList.remove('sn4-dragging');
        track.style.transition = '';
        var dx = (e && typeof e.clientX === 'number') ? e.clientX - dragStartX : 0;
        var step = getStep() || 1;
        var moved = Math.round(-dx / step);
        if (moved === 0 && Math.abs(dx) > step * 0.2) { moved = dx < 0 ? 1 : -1; }  // pequeño arrastre = 1 diapositiva
        goTo(state.currentIndex + moved);
        startAutoplay();
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      function onDragClickCapture(e) {
        if (draggedFar) { e.preventDefault(); e.stopPropagation(); draggedFar = false; }
      }

      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerUp);
      track.addEventListener('click', onDragClickCapture, true);
      Array.prototype.forEach.call(track.querySelectorAll('img, a'), function (el) { el.setAttribute('draggable', 'false'); });

      /* ===== SCROLL HORIZONTAL FLUIDO (rueda / trackpad) en escritorio ===== */
      var wheelActive = false, wheelOffset = 0, wheelEndTimer = null;

      function clampWheelOffset(o) {
        var min = -getMaxIndex() * getStep();
        if (o > 0) { o = 0; }
        if (o < min) { o = min; }
        return o;
      }
      function onWheel(e) {
        if (isMobile()) return;
        var dx = e.deltaX;
        if (e.shiftKey && Math.abs(e.deltaY) > Math.abs(dx)) { dx = e.deltaY; }
        if (!e.shiftKey && Math.abs(dx) <= Math.abs(e.deltaY)) return;   // gesto vertical: no interferir con el scroll de la página
        if (getMaxIndex() <= 0) return;
        e.preventDefault();
        stopAutoplay();

        if (!wheelActive) {                                             // empieza el gesto: parte de la posición actual
          wheelActive = true;
          wheelOffset = -state.currentIndex * getStep();
          track.style.transition = 'none';
        }
        wheelOffset = clampWheelOffset(wheelOffset - dx);               // sigue la rueda en tiempo real
        track.style.transform = 'translate3d(' + wheelOffset + 'px, 0, 0)';

        var step = getStep() || 1;                                     // actualiza contador/flechas sin mover
        var prov = Math.max(0, Math.min(getMaxIndex(), Math.round(-wheelOffset / step)));
        if (prov !== state.currentIndex) { state.currentIndex = prov; updateCounter(); updateButtons(); updateProgress(); }

        if (wheelEndTimer) clearTimeout(wheelEndTimer);
        wheelEndTimer = setTimeout(function () {                        // al dejar de hacer scroll: se detiene y ajusta a la tarjeta más cercana
          wheelActive = false;
          track.style.transition = '';
          var s = getStep() || 1;
          var idx = Math.max(0, Math.min(getMaxIndex(), Math.round(-wheelOffset / s)));
          goTo(idx);
          startAutoplay();
        }, 140);
      }
      viewport.addEventListener('wheel', onWheel, { passive: false });

      var atcButtons = root.querySelectorAll('.sn4-atc:not(.sn4-atc--link):not(.sn4-atc--disabled)');

      function addToCartV4(button) {
        var variantId = button.dataset.variantId;
        var title = button.dataset.productTitle || '';
        if (!variantId || button.dataset.state === 'loading') return;

        var label = button.querySelector('.sn4-atc-label');
        var originalText = label ? label.textContent : button.textContent;

        button.dataset.state = 'loading';
        button.disabled = true;
        if (label) label.textContent = 'Añadiendo…';
        if (feedback) feedback.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw err; }); }
            return res.json();
          })
          .then(function (data) {
            button.dataset.state = 'success';
            if (label) label.textContent = 'Añadido ✓';

            // Ventana «Añadido a la cesta» (sections/zh-atc-popup.liquid)
            document.dispatchEvent(new CustomEvent('zh:cart-added', {
              detail: { item: data, variantId: variantId, quantity: 1 }
            }));

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
            try {
              document.dispatchEvent(new CustomEvent('cart-items-updated', { bubbles: true }));
            } catch (e) { /* noop */ }

            setTimeout(function () {
              button.dataset.state = '';
              button.disabled = false;
              if (label) label.textContent = originalText;
            }, 1800);
          })
          .catch(function (err) {
            button.dataset.state = '';
            button.disabled = false;
            if (label) label.textContent = originalText;
            var message = (err && err.description) || (err && err.message) || 'No se pudo añadir a la cesta.';
            if (feedback) feedback.textContent = (title ? title + ': ' : '') + message;
          });
      }

      function onAtcClick(e) { addToCartV4(e.currentTarget); }
      atcButtons.forEach(function (btn) { btn.addEventListener('click', onAtcClick); });

      updateCounter();
      updateButtons();
      applyTransform();
      updateProgress();
      startAutoplay();

      instances.set(root, {
        destroy: function () {
          if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
          if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
          root.removeEventListener('keydown', onKeydown);
          window.removeEventListener('resize', onResize);
          viewport.removeEventListener('scroll', onScroll);
          atcButtons.forEach(function (btn) { btn.removeEventListener('click', onAtcClick); });
          stopAutoplay();
          document.removeEventListener('visibilitychange', onVisibility);
          root.removeEventListener('mouseenter', stopAutoplay);
          root.removeEventListener('mouseleave', startAutoplay);
          root.removeEventListener('focusin', stopAutoplay);
          root.removeEventListener('focusout', startAutoplay);
          root.removeEventListener('touchstart', stopAutoplay);
          track.removeEventListener('pointerdown', onPointerDown);
          track.removeEventListener('pointermove', onPointerMove);
          track.removeEventListener('pointerup', onPointerUp);
          track.removeEventListener('pointercancel', onPointerUp);
          track.removeEventListener('click', onDragClickCapture, true);
          viewport.removeEventListener('wheel', onWheel);
          if (wheelEndTimer) clearTimeout(wheelEndTimer);
          if (resizeRaf) cancelAnimationFrame(resizeRaf);
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          if (scrollEndTimer) clearTimeout(scrollEndTimer);
        }
      });
    }

    function destroyV4(root) {
      if (!root) return;
      var inst = instances.get(root);
      if (inst && typeof inst.destroy === 'function') { inst.destroy(); }
      instances.delete(root);
    }

    function initAll() {
      var roots = document.querySelectorAll('[id^="sn4-"][data-section-id]');
      Array.prototype.forEach.call(roots, initV4);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[id^="sn4-"][data-section-id]');
      if (root) initV4(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[id^="sn4-"][data-section-id]');
      if (root) destroyV4(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v10"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var MOBILE_QUERY = '(max-width: 767px)';
    var instances = new Map();

    function initZhf(root) {
      if (!root || instances.has(root)) return;
      var mql = window.matchMedia(MOBILE_QUERY);
      var columns = root.querySelectorAll('[data-zhf-column]');

      function applyMode() {
        var isMobile = mql.matches;
        columns.forEach(function (col) {
          if (isMobile) {
            col.removeAttribute('data-zhf-locked');
            col.open = false;
          } else {
            if (!col.open) col.open = true;
            col.setAttribute('data-zhf-locked', 'true');
          }
        });
      }
      function onToggle(e) {
        var col = e.target;
        if (!col || !col.matches('[data-zhf-column]')) return;
        if (col.getAttribute('data-zhf-locked') === 'true' && !col.open) col.open = true;
      }
      function onSummaryClick(e) {
        var summary = e.target.closest('.zhf-summary');
        if (!summary) return;
        var col = summary.parentElement;
        if (col && col.getAttribute('data-zhf-locked') === 'true') e.preventDefault();
      }
      function onSummaryKey(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var summary = e.target.closest('.zhf-summary');
        if (!summary) return;
        var col = summary.parentElement;
        if (col && col.getAttribute('data-zhf-locked') === 'true') e.preventDefault();
      }

      applyMode();
      var listeners = { toggle: onToggle, click: onSummaryClick, keydown: onSummaryKey, mqlChange: applyMode };
      columns.forEach(function (col) { col.addEventListener('toggle', listeners.toggle); });
      root.addEventListener('click', listeners.click);
      root.addEventListener('keydown', listeners.keydown);
      if (mql.addEventListener) { mql.addEventListener('change', listeners.mqlChange); }
      else if (mql.addListener) { mql.addListener(listeners.mqlChange); }
      instances.set(root, { mql: mql, columns: columns, listeners: listeners });
    }

    function cleanupZhf(root) {
      var inst = instances.get(root);
      if (!inst) return;
      inst.columns.forEach(function (col) { col.removeEventListener('toggle', inst.listeners.toggle); });
      root.removeEventListener('click', inst.listeners.click);
      root.removeEventListener('keydown', inst.listeners.keydown);
      if (inst.mql.removeEventListener) { inst.mql.removeEventListener('change', inst.listeners.mqlChange); }
      else if (inst.mql.removeListener) { inst.mql.removeListener(inst.listeners.mqlChange); }
      instances.delete(root);
    }

    document.querySelectorAll('[id^="zhf-"]').forEach(initZhf);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[id^="zhf-"]'); if (root) initZhf(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[id^="zhf-"]'); if (root) cleanupZhf(root);
    });
    document.addEventListener('shopify:section:reorder', function (e) {
      var root = e.target.querySelector('[id^="zhf-"]'); if (root) { cleanupZhf(root); initZhf(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   hero-video.liquid — JavaScript de la sección
   Se ejecuta una vez por cada instancia de sección en la página.
   ============================================================ */

(function () {
  'use strict';

  /**
   * initHeroVideo(sectionEl)
   * Inicializa la lógica de control del vídeo para una sección concreta.
   * Se llama tanto en carga inicial como cuando el customizer recarga la sección.
   */
  function initHeroVideo(sectionEl) {
    if (!sectionEl) return;

    var videos = sectionEl.querySelectorAll('.hero-video__video');
    if (!videos.length) return;

    // ── 1. prefers-reduced-motion: pausar vídeos y mostrar poster ──
    //    (el CSS ya oculta el vídeo, pero también lo pausamos para
    //     detener la descarga de datos en algunos navegadores)
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function handleReduceMotion() {
      videos.forEach(function (video) {
        if (reduceMotion.matches) {
          video.pause();
        } else {
          // Solo reproducir si el elemento es visible (ver apartado 2)
          if (isVisible(sectionEl)) video.play().catch(function () {});
        }
      });
    }

    reduceMotion.addEventListener('change', handleReduceMotion);
    handleReduceMotion(); // Ejecutar en el arranque

    // ── 2. IntersectionObserver: pausar cuando el hero sale del viewport ──
    //    Ahorra batería en móvil y CPU en general.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (reduceMotion.matches) return;
            videos.forEach(function (video) {
              if (entry.isIntersecting) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(sectionEl);
    }

    // ── 3. Pausa cuando la pestaña pierde el foco ──
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(function (v) { v.pause(); });
      } else {
        if (!reduceMotion.matches && isVisible(sectionEl)) {
          videos.forEach(function (v) { v.play().catch(function () {}); });
        }
      }
    });
  }

  // Utilidad: comprueba si un elemento está en el viewport
  function isVisible(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  // ── Inicialización en carga de página ──
  document.querySelectorAll('.hero-video-section').forEach(initHeroVideo);

  // ── Soporte para el customizer de Shopify (recarga de sección) ──
  //    Cuando el merchant edita la sección en el editor, Shopify
  //    emite el evento 'shopify:section:load' y necesitamos reinicializar.
  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.hero-video-section');
    if (sectionEl) initHeroVideo(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-badge-v9"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var observersV9 = new WeakMap();
    var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function hydrateLinksV9(root) {
      var placeholders = root.querySelectorAll('.sn9-link-placeholder');
      placeholders.forEach(function(placeholder) {
        if (placeholder.dataset.sn9Hydrated === 'true') return;
        placeholder.dataset.sn9Hydrated = 'true';

        var url  = placeholder.getAttribute('data-sn9-link-url');
        var text = placeholder.getAttribute('data-sn9-link-text');
        if (!url || !text) return;

        var link = document.createElement('a');
        link.className = 'sn9-link';
        link.href = url;
        link.setAttribute('aria-label', text);

        var span = document.createElement('span');
        span.className = 'sn9-link-text';
        span.textContent = text;
        link.appendChild(span);

        var icon = document.createElement('span');
        icon.className = 'sn9-link-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = ARROW_SVG;
        link.appendChild(icon);

        placeholder.parentNode.replaceChild(link, placeholder);
      });
    }

    function initV9(root) {
      if (!root || root.dataset.sn9Inited === 'true') return;
      root.dataset.sn9Inited = 'true';

      hydrateLinksV9(root);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.setAttribute('data-sn9-visible', 'true');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

        io.observe(root);
        observersV9.set(root, io);
      } else {
        root.setAttribute('data-sn9-visible', 'true');
      }
    }

    function cleanupV9(root) {
      if (!root) return;
      var io = observersV9.get(root);
      if (io) { io.disconnect(); observersV9.delete(root); }
      root.removeAttribute('data-sn9-inited');
      root.removeAttribute('data-sn9-visible');
    }

    function initAllV9() {
      document.querySelectorAll('.sn9-section[id^="sn9-"]').forEach(initV9);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllV9);
    } else {
      initAllV9();
    }

    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target.querySelector('.sn9-section[id^="sn9-"]');
      if (root) initV9(root);
    });
    document.addEventListener('shopify:section:unload', function(e) {
      var root = e.target.querySelector('.sn9-section[id^="sn9-"]');
      if (root) cleanupV9(root);
    });
    document.addEventListener('shopify:section:select', function(e) {
      var root = e.target.querySelector('.sn9-section[id^="sn9-"]');
      if (root) { root.setAttribute('data-sn9-visible', 'true'); hydrateLinksV9(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-con-mosaico"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    var seen = new WeakSet();
    function initSn10(root) {
      if (!root || seen.has(root)) return;
      seen.add(root);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting) { e.target.setAttribute('data-sn10-visible', 'true'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        io.observe(root);
      } else {
        root.setAttribute('data-sn10-visible', 'true');
      }
    }
    function initAll() { document.querySelectorAll('.sn10-section[id^="sn10-"]').forEach(initSn10); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', function(e) {
      var r = e.target.querySelector('.sn10-section[id^="sn10-"]'); if (r) { seen.delete(r); r.setAttribute('data-sn10-visible','true'); initSn10(r); }
    });
    document.addEventListener('shopify:section:select', function(e) {
      var r = e.target.querySelector('.sn10-section[id^="sn10-"]'); if (r) r.setAttribute('data-sn10-visible','true');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-style"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(root) {
      if (!root || root.dataset.zhprInit === '1') return;
      root.dataset.zhprInit = '1';

      var track = root.querySelector('[data-zhpr-track]');
      var viewport = root.querySelector('[data-zhpr-viewport]');

      // ── Fallback fetch de recomendaciones si la página no las inyectó ──
      var fetchUrl = root.getAttribute('data-fetch-recommendations');
      if (fetchUrl && track && track.querySelector('.zh-product-recommendations-empty')) {
        fetch(fetchUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshTrack = doc.querySelector('[data-zhpr-track]');
            if (freshTrack && !freshTrack.querySelector('.zh-product-recommendations-empty')) {
              track.innerHTML = freshTrack.innerHTML;
            }
            root.removeAttribute('data-fetch-recommendations');
            setupCarousel();
          })
          .catch(function () { root.removeAttribute('data-fetch-recommendations'); });
      }

      // ── Wishlist (toggle visual, hook para integración externa) ──
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-zhpr-wishlist]');
        if (!btn) return;
        btn.classList.toggle('is-active');
        var id = btn.getAttribute('data-product-id');
        root.dispatchEvent(new CustomEvent('zhpr:wishlist', {
          bubbles: true,
          detail: { productId: id, active: btn.classList.contains('is-active') }
        }));
      });

      // ── Añadir al carrito vía AJAX ──
      root.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-zhpr-atc-form]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[data-zhpr-atc]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.setAttribute('disabled', ''); btn.textContent = '…'; }

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('input[name="id"]').value, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (btn) { btn.textContent = '✓'; }
            // Ventana «Añadido a la cesta» (sections/zh-atc-popup.liquid); con error, Shopify devuelve «status»
            if (data && !data.status) {
              document.dispatchEvent(new CustomEvent('zh:cart-added', {
                detail: { item: data, variantId: form.querySelector('input[name="id"]').value, quantity: 1 }
              }));
            }
            document.dispatchEvent(new CustomEvent('zhpr:added'));
            // refrescar el drawer/bubble del carrito si el tema lo expone
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              if (btn) { btn.removeAttribute('disabled'); btn.textContent = original; }
            }, 1400);
          })
          .catch(function () {
            if (btn) { btn.removeAttribute('disabled'); btn.textContent = original; }
          });
      });

      // ── Carrusel (Vanilla JS) ──
      function setupCarousel() {
        if (root.getAttribute('data-carousel') !== 'true') return;
        if (!track || !track.classList.contains('is-carousel')) return;

        var prev = root.querySelector('[data-zhpr-prev]');
        var next = root.querySelector('[data-zhpr-next]');
        if (!prev || !next) return;

        function scrollAmount() {
          var first = track.querySelector('.zh-product-recommendations-item');
          if (!first) return track.clientWidth;
          var style = getComputedStyle(track);
          var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
          return first.getBoundingClientRect().width + gap;
        }

        function update() {
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          var overflows = maxScroll > 2;
          prev.hidden = !overflows || track.scrollLeft <= 2;
          next.hidden = !overflows || track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', function () {
          window.requestAnimationFrame(update);
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      setupCarousel();
    }

    function initAll() {
      document.querySelectorAll('.zh-product-recommendations-wrapper').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Compatibilidad con el Theme Editor de Shopify
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.zh-product-recommendations-wrapper');
      if (el) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-archivo-featured-products-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Punto de entrada: localizamos la sección por su id único
    var roots = document.querySelectorAll('[id^="sn3-"].sn3-section');
    if (!roots || roots.length === 0) return;

    function setStatusV3(root, msg) {
      var sr = root.querySelector('[data-sn3-status]');
      if (sr) sr.textContent = msg || '';
    }

    function addToCartV3(root, card, btn) {
      var variantId = card.getAttribute('data-sn3-variant-id');
      if (!variantId) return;

      var label = btn.querySelector('.sn3-add-label');
      var originalText = label ? label.textContent : '';

      btn.setAttribute('data-sn3-loading', 'true');
      btn.removeAttribute('data-sn3-error');
      btn.removeAttribute('data-sn3-success');
      if (label) label.textContent = 'Añadiendo…';
      btn.setAttribute('aria-busy', 'true');

      var body = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      };

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.removeAttribute('data-sn3-loading');
        btn.setAttribute('data-sn3-success', 'true');
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = 'Añadido ✓';
        setStatusV3(root, 'Producto añadido al carrito.');

        // Notificar al tema (mini-cart de Dawn y otros listeners)
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          // Dawn (PUB/SUB ya no es estándar en versiones nuevas, pero el evento de arriba lo cubre)
          if (typeof window.PubSub !== 'undefined' && typeof window.PubSub.publish === 'function') {
            window.PubSub.publish('cart-update', {});
          }
        } catch (e) { /* noop */ }

        setTimeout(function () {
          btn.removeAttribute('data-sn3-success');
          if (label) label.textContent = originalText;
        }, 2000);
      })
      .catch(function (err) {
        btn.removeAttribute('data-sn3-loading');
        btn.removeAttribute('aria-busy');
        btn.setAttribute('data-sn3-error', 'true');
        if (label) label.textContent = 'Error, reintentar';
        setStatusV3(root, 'No se pudo añadir el producto. Inténtalo de nuevo.');
        // eslint-disable-next-line no-console
        console.error('[sn3] addToCart error:', err);

        setTimeout(function () {
          btn.removeAttribute('data-sn3-error');
          if (label) label.textContent = originalText;
        }, 2500);
      });
    }

    function bindCardV3(root, card) {
      // Botón añadir (solo el botón button[data-sn3-add])
      var addBtn = card.querySelector('button.sn3-add-btn[data-sn3-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (addBtn.hasAttribute('disabled')) return;
          if (addBtn.getAttribute('data-sn3-loading') === 'true') return;
          addToCartV3(root, card, addBtn);
        });
      }

      // Wishlist (toggle visual; integración real depende del tema)
      var wish = card.querySelector('.sn3-wishlist-btn');
      if (wish) {
        wish.addEventListener('click', function (e) {
          e.preventDefault();
          var pressed = wish.getAttribute('aria-pressed') === 'true';
          wish.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          var pid = card.getAttribute('data-sn3-product-id');
          try {
            document.dispatchEvent(new CustomEvent('sn3:wishlist-toggle', {
              bubbles: true,
              detail: { productId: pid, active: !pressed }
            }));
          } catch (err) { /* noop */ }
        });
      }
    }

    // Inicialización por cada instancia de la sección (puede haber varias)
    roots.forEach(function (root) {
      var cards = root.querySelectorAll('.sn3-card');
      cards.forEach(function (card) { bindCardV3(root, card); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-archivo-featured-products-v5"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SN5_CLEANUPS = new WeakMap();

    /* ----------------------------------------------------------------------
       initSn5 — inicializa una instancia de la sección
       ---------------------------------------------------------------------- */
    function initSn5(root) {
      if (!root || root.dataset.sn5Initialized === '1') return;
      root.dataset.sn5Initialized = '1';

      var cleanups = [];

      var atcButtons = root.querySelectorAll('.sn5-atc:not(.sn5-atc-link)');
      atcButtons.forEach(function (btn) {
        var handler = function (e) { handleAddToCartV5(e, btn, root); };
        btn.addEventListener('click', handler);
        cleanups.push(function () { btn.removeEventListener('click', handler); });
      });

      SN5_CLEANUPS.set(root, cleanups);
    }

    /* ----------------------------------------------------------------------
       handleAddToCartV5 — añade un producto al carrito vía fetch
       ---------------------------------------------------------------------- */
    function handleAddToCartV5(event, btn, root) {
      event.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.classList.contains('is-loading')) return;

      var label   = btn.querySelector('.sn5-atc-label');
      var origTxt = btn.getAttribute('data-default-text') || (label ? label.textContent : 'Añadir');

      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'disabled');
      if (label) label.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
        return response.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        if (label) label.textContent = '✓ Añadido';

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update',  { bubbles: true }));

        setTimeout(function () {
          btn.classList.remove('is-success');
          btn.removeAttribute('disabled');
          if (label) label.textContent = origTxt;
        }, 1800);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        if (label) label.textContent = origTxt;
        showToastV5(root, (err && err.description) || 'No se pudo añadir al carrito');
      });
    }

    /* ----------------------------------------------------------------------
       showToastV5 — mensaje temporal de error/aviso
       ---------------------------------------------------------------------- */
    function showToastV5(root, message) {
      var toast = root.querySelector('.sn5-toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toast._sn5Timer);
      toast._sn5Timer = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2800);
    }

    /* ----------------------------------------------------------------------
       cleanupSn5 — desmonta listeners
       ---------------------------------------------------------------------- */
    function cleanupSn5(root) {
      if (!root) return;
      var cleanups = SN5_CLEANUPS.get(root);
      if (cleanups) {
        cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
        SN5_CLEANUPS.delete(root);
      }
      delete root.dataset.sn5Initialized;
    }

    /* ----------------------------------------------------------------------
       Boot
       ---------------------------------------------------------------------- */
    document.querySelectorAll('[id^="sn5-"]').forEach(initSn5);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[id^="sn5-"]');
      if (root) initSn5(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[id^="sn5-"]');
      if (root) cleanupSn5(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-archivo-featured-products-v7"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var cardRegistry = new WeakMap();

    function initCardV7(cardEl) {
      if (!cardEl || cardRegistry.has(cardEl)) return;

      var state = {
        atcBtn: cardEl.querySelector('[data-sn7-atc]'),
        feedback: cardEl.querySelector('[data-sn7-feedback]'),
        video: cardEl.querySelector('[data-sn7-video]'),
        abortCtrl: null,
        io: null,
        onClick: null
      };

      if (state.atcBtn) {
        state.onClick = function(e) {
          e.preventDefault();
          handleAddToCartV7(cardEl, state);
        };
        state.atcBtn.addEventListener('click', state.onClick);
      }

      if (state.video && 'IntersectionObserver' in window) {
        state.io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              if (state.video.preload === 'none') {
                state.video.preload = 'metadata';
              }
              var p = state.video.play();
              if (p && typeof p.catch === 'function') p.catch(function(){});
            } else {
              if (!state.video.paused) state.video.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.1 });
        state.io.observe(state.video);
      }

      cardRegistry.set(cardEl, state);
    }

    function cleanupCardV7(cardEl) {
      var state = cardRegistry.get(cardEl);
      if (!state) return;
      if (state.atcBtn && state.onClick) {
        state.atcBtn.removeEventListener('click', state.onClick);
      }
      if (state.abortCtrl) {
        try { state.abortCtrl.abort(); } catch (e) {}
      }
      if (state.io) {
        try { state.io.disconnect(); } catch (e) {}
      }
      cardRegistry.delete(cardEl);
    }

    function handleAddToCartV7(cardEl, state) {
      var btn = state.atcBtn;
      var variantId = btn.getAttribute('data-sn7-variant-id');
      if (!variantId) return;

      if (state.abortCtrl) {
        try { state.abortCtrl.abort(); } catch (e) {}
      }
      state.abortCtrl = new AbortController();

      btn.classList.add('sn7-is-loading');
      btn.setAttribute('aria-busy', 'true');
      setFeedbackV7(state.feedback, '', '');

      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        signal: state.abortCtrl.signal
      })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function() {
          btn.classList.remove('sn7-is-loading');
          btn.classList.add('sn7-is-added');
          btn.removeAttribute('aria-busy');
          var labelEl = btn.querySelector('.sn7-btn__label');
          var originalLabel = labelEl ? labelEl.textContent : '';
          if (labelEl) labelEl.textContent = 'Anadido';
          setFeedbackV7(state.feedback, 'Producto anadido al carrito', 'success');

          document.dispatchEvent(new CustomEvent('sn7:add-to-cart', {
            detail: { variantId: variantId, sectionId: cardEl.closest('[id^="sn7-"]').id }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function() {
            btn.classList.remove('sn7-is-added');
            if (labelEl && originalLabel) labelEl.textContent = originalLabel;
            setFeedbackV7(state.feedback, '', '');
          }, 2200);
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          btn.classList.remove('sn7-is-loading');
          btn.removeAttribute('aria-busy');
          setFeedbackV7(state.feedback, 'No se pudo anadir el producto. Intentalo de nuevo.', 'error');
        });
    }

    function setFeedbackV7(el, msg, type) {
      if (!el) return;
      el.textContent = msg || '';
      el.classList.remove('sn7-is-error', 'sn7-is-success');
      if (type === 'error') el.classList.add('sn7-is-error');
      if (type === 'success') el.classList.add('sn7-is-success');
    }

    function initLayoutV7(root) {
      if ('IntersectionObserver' in window) {
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top > vh) {
          root.classList.add('sn7-cv-auto');
        }
      }
    }

    function initV7(root) {
      if (!root || root.dataset.sn7Initialized === 'true') return;
      initLayoutV7(root);
      root.querySelectorAll('[data-sn7-card]').forEach(initCardV7);
      root.dataset.sn7Initialized = 'true';
    }

    function cleanupV7(root) {
      if (!root) return;
      root.querySelectorAll('[data-sn7-card]').forEach(cleanupCardV7);
      root.dataset.sn7Initialized = 'false';
    }

    document.querySelectorAll('[id^="sn7-"]').forEach(initV7);

    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target.querySelector('[id^="sn7-"]');
      if (root) initV7(root);
    });

    document.addEventListener('shopify:section:unload', function(e) {
      var root = e.target.querySelector('[id^="sn7-"]');
      if (root) cleanupV7(root);
    });

    document.addEventListener('shopify:section:select', function(e) {
      var root = e.target.querySelector('[id^="sn7-"]');
      if (root && root.scrollIntoView) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-archivo-featured-products-v8"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Mapa root → handlers, para poder limpiar al desmontar la sección
    var registry = new WeakMap();

    function getPerView(root) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var attr = isMobile ? 'sn8PerMobile' : 'sn8PerDesktop';
      var n = parseInt(root.dataset[attr], 10);
      return (isNaN(n) || n < 1) ? 1 : n;
    }

    function getPages(track, perView) {
      var total = track.querySelectorAll('.sn8-card').length;
      if (!total) return 1;
      return Math.max(1, Math.ceil(total / perView));
    }

    function getCurrentPage(track, perView) {
      var cards = track.querySelectorAll('.sn8-card');
      if (!cards.length) return 1;
      var cardWidth = cards[0].getBoundingClientRect().width;
      if (!cardWidth) return 1;
      var pageWidth = cardWidth * perView;
      var page = Math.round(track.scrollLeft / pageWidth) + 1;
      return Math.min(Math.max(page, 1), getPages(track, perView));
    }

    function updateUI(root) {
      var track    = root.querySelector('[data-sn8-track]');
      if (!track) return;
      var perView  = getPerView(root);
      var pages    = getPages(track, perView);
      var current  = getCurrentPage(track, perView);
      var currEl   = root.querySelector('[data-sn8-current]');
      var totalEl  = root.querySelector('[data-sn8-total]');
      var prevBtn  = root.querySelector('[data-sn8-prev]');
      var nextBtn  = root.querySelector('[data-sn8-next]');
      var nav      = root.querySelector('[data-sn8-nav]');

      if (currEl)  currEl.textContent  = current;
      if (totalEl) totalEl.textContent = pages;

      if (prevBtn) prevBtn.setAttribute('aria-disabled', current <= 1 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', current >= pages ? 'true' : 'false');

      if (nav) {
        nav.style.visibility = pages <= 1 ? 'hidden' : '';
      }
    }

    function goToPage(root, page) {
      var track   = root.querySelector('[data-sn8-track]');
      if (!track) return;
      var cards   = track.querySelectorAll('.sn8-card');
      if (!cards.length) return;
      var perView = getPerView(root);
      var pages   = getPages(track, perView);
      var target  = Math.min(Math.max(page, 1), pages);
      var cardWidth = cards[0].getBoundingClientRect().width;
      var left    = cardWidth * perView * (target - 1);
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function addToCartV8(button, root) {
      var variantId = button.getAttribute('data-sn8-variant-id');
      if (!variantId || button.classList.contains('is-loading')) return;

      var feedback = button.querySelector('[data-sn8-atc-feedback]');
      button.classList.remove('is-added', 'is-error');
      button.classList.add('is-loading');
      if (feedback) feedback.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          if (feedback) feedback.textContent = 'Añadido ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            button.classList.remove('is-added');
            if (feedback) feedback.textContent = '';
          }, 2200);
        })
        .catch(function () {
          button.classList.remove('is-loading');
          button.classList.add('is-error');
          if (feedback) feedback.textContent = 'Error';
          setTimeout(function () {
            button.classList.remove('is-error');
            if (feedback) feedback.textContent = '';
          }, 2500);
        });
    }

    function initV8(root) {
      if (!root || registry.has(root)) return;

      var track   = root.querySelector('[data-sn8-track]');
      var prevBtn = root.querySelector('[data-sn8-prev]');
      var nextBtn = root.querySelector('[data-sn8-next]');
      if (!track) return;

      var scrollRaf = null;
      var resizeRaf = null;

      var handlers = {
        onScroll: function () {
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          scrollRaf = requestAnimationFrame(function () {
            updateUI(root);
          });
        },
        onResize: function () {
          if (resizeRaf) cancelAnimationFrame(resizeRaf);
          resizeRaf = requestAnimationFrame(function () {
            updateUI(root);
          });
        },
        onPrev: function () {
          if (prevBtn.getAttribute('aria-disabled') === 'true') return;
          var perView = getPerView(root);
          var current = getCurrentPage(track, perView);
          goToPage(root, current - 1);
        },
        onNext: function () {
          if (nextBtn.getAttribute('aria-disabled') === 'true') return;
          var perView = getPerView(root);
          var current = getCurrentPage(track, perView);
          goToPage(root, current + 1);
        },
        onClickATC: function (e) {
          var btn = e.target.closest('[data-sn8-atc]');
          if (!btn || !root.contains(btn)) return;
          e.preventDefault();
          e.stopPropagation();
          addToCartV8(btn, root);
        },
        cancelScrollRaf: function () {
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          if (resizeRaf) cancelAnimationFrame(resizeRaf);
        }
      };

      track.addEventListener('scroll', handlers.onScroll, { passive: true });
      window.addEventListener('resize', handlers.onResize);
      if (prevBtn) prevBtn.addEventListener('click', handlers.onPrev);
      if (nextBtn) nextBtn.addEventListener('click', handlers.onNext);
      root.addEventListener('click', handlers.onClickATC);

      registry.set(root, handlers);
      updateUI(root);
    }

    function cleanupV8(root) {
      if (!root) return;
      var handlers = registry.get(root);
      if (!handlers) return;
      var track   = root.querySelector('[data-sn8-track]');
      var prevBtn = root.querySelector('[data-sn8-prev]');
      var nextBtn = root.querySelector('[data-sn8-next]');

      if (track)   track.removeEventListener('scroll', handlers.onScroll);
      window.removeEventListener('resize', handlers.onResize);
      if (prevBtn) prevBtn.removeEventListener('click', handlers.onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', handlers.onNext);
      root.removeEventListener('click', handlers.onClickATC);
      handlers.cancelScrollRaf();
      registry.delete(root);
    }

    // Inicializar todas las instancias presentes en el DOM
    document.querySelectorAll('[id^="sn8-"]').forEach(initV8);

    // Soporte para el customizer de Shopify
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[id^="sn8-"]');
      if (root) initV8(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[id^="sn8-"]');
      if (root) cleanupV8(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-archivo-novedades-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(section) {
      var sectionId = section.dataset.sectionId;
      var track = section.querySelector('[id^="sn-track-"]');
      if (!track) return;

      var prevBtn = section.querySelector('[data-nav="prev"]');
      var nextBtn = section.querySelector('[data-nav="next"]');
      var dotsContainer = section.querySelector('[data-dots-container]');
      var cards = track.querySelectorAll('.sn-card');
      if (!cards.length) return;

      // ===== Build dots =====
      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        for (var i = 0; i < cards.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sn-novedades__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
          dot.dataset.index = String(i);
          if (i === 0) dot.setAttribute('aria-selected', 'true');
          dot.addEventListener('click', function (e) {
            var idx = parseInt(e.currentTarget.dataset.index, 10);
            scrollToIndex(idx);
          });
          dotsContainer.appendChild(dot);
        }
      }

      function getCardStep() {
        if (cards.length < 2) return cards[0] ? cards[0].offsetWidth : 0;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }

      function scrollToIndex(idx) {
        var step = getCardStep();
        track.scrollTo({ left: step * idx, behavior: 'smooth' });
      }

      function currentIndex() {
        var step = getCardStep();
        if (step === 0) return 0;
        return Math.round(track.scrollLeft / step);
      }

      function updateUI() {
        var idx = currentIndex();
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.sn-novedades__dot');
          dots.forEach(function (d, i) {
            if (i === idx) {
              d.setAttribute('aria-selected', 'true');
            } else {
              d.removeAttribute('aria-selected');
            }
          });
        }
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= cards.length - 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToIndex(Math.max(0, currentIndex() - 1));
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToIndex(Math.min(cards.length - 1, currentIndex() + 1));
        });
      }

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateUI, 80);
      });

      window.addEventListener('resize', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateUI, 100);
      });

      buildDots();
      updateUI();

      // ===== Add to cart (AJAX) =====
      var addButtons = section.querySelectorAll('[data-add-to-cart]');
      addButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.dataset.variantId;
          if (!variantId) return;

          var textEl = btn.querySelector('.sn-card__add-btn-text');
          var originalText = textEl ? textEl.textContent : '';

          btn.dataset.adding = 'true';
          btn.disabled = true;
          if (textEl) textEl.textContent = 'Añadiendo…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }]
            })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              btn.dataset.adding = 'false';
              btn.dataset.added = 'true';
              if (textEl) textEl.textContent = '✓ Añadido';

              // Notify theme to refresh cart drawer/count
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:added', {
                bubbles: true,
                detail: { sectionId: sectionId, variantId: variantId }
              }));

              setTimeout(function () {
                btn.dataset.added = 'false';
                btn.disabled = false;
                if (textEl) textEl.textContent = originalText;
              }, 1800);
            })
            .catch(function () {
              btn.dataset.adding = 'false';
              btn.dataset.added = 'true';
              if (textEl) textEl.textContent = originalText;
            });
        });
      });
    }

    function initAll() {
      var sections = document.querySelectorAll('.sn-novedades');
      sections.forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify section events (theme editor)
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.sn-novedades');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-product-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.zh-product-buy-section');
  sections.forEach(function (root) {
    if (root.dataset.zhInit) return;
    root.dataset.zhInit = '1';

    var main = root.querySelector('[data-zh-main]');
    var thumbs = root.querySelectorAll('[data-zh-thumb]');
    var qtyInput = root.querySelector('[data-zh-qty]');
    var minus = root.querySelector('[data-zh-minus]');
    var plus = root.querySelector('[data-zh-plus]');
    var addBtn = root.querySelector('[data-zh-add]');
    var addPrice = root.querySelector('[data-zh-add-price]');
    var addCompare = root.querySelector('[data-zh-add-compare]');
    var feedback = root.querySelector('[data-zh-feedback]');
    var variantSelect = root.querySelector('[data-zh-variant-select]');
    var shareBtn = root.querySelector('[data-zh-share]');
    var priceBox = root.querySelector('[data-zh-price]');

    // Thumbnails -> scroll main to matching slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-zh-thumb');
        var slide = main.querySelector('[data-zh-slide="' + idx + '"]');
        if (slide) main.scrollTo({ left: slide.offsetLeft, top: slide.offsetTop, behavior: 'smooth' });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Quantity
    function getQty() { var v = parseInt(qtyInput.value, 10); return (isNaN(v) || v < 1) ? 1 : v; }

    function zhFormatMoney(cents) {
      var fmt = addBtn ? (addBtn.getAttribute('data-money-format') || '') : '';
      var dec = (cents / 100).toFixed(2);
      var comma = dec.replace('.', ',');
      var whole = String(Math.round(cents / 100));
      if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) return fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole);
      if (fmt.indexOf('amount_with_comma_separator') !== -1) return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma);
      if (fmt.indexOf('amount_no_decimals') !== -1) return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
      if (fmt.indexOf('amount') !== -1) return fmt.replace(/\{\{\s*amount\s*\}\}/, dec);
      return comma + '\u20ac';
    }

    function updateAddPrice() {
      if (!addBtn || !addPrice) return;
      var unit = parseInt(addBtn.getAttribute('data-unit-price'), 10);
      if (isNaN(unit)) return;
      var qty = getQty();
      addPrice.textContent = zhFormatMoney(unit * qty);
      var compareUnit = parseInt(addBtn.getAttribute('data-compare-price'), 10) || 0;
      if (addCompare) {
        if (compareUnit > unit) {
          addCompare.textContent = zhFormatMoney(compareUnit * qty);
          addCompare.hidden = false;
          addPrice.classList.add('on-sale');
        } else {
          addCompare.hidden = true;
          addPrice.classList.remove('on-sale');
        }
      }
    }

    function qtyChanged() { updateAddPrice(); }

    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, getQty() - 1); qtyChanged(); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = getQty() + 1; qtyChanged(); });
    qtyInput.addEventListener('change', function () { qtyInput.value = getQty(); qtyChanged(); });

    // Variant change
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        addBtn.setAttribute('data-variant', opt.value);
        addBtn.setAttribute('data-unit-price', opt.getAttribute('data-price-raw') || '0');
        addBtn.setAttribute('data-compare-price', opt.getAttribute('data-compare-raw') || '0');
        updateAddPrice();

        var compareRaw = parseInt(opt.getAttribute('data-compare-raw'), 10) || 0;
        var priceRaw = parseInt(opt.getAttribute('data-price-raw'), 10) || 0;
        if (priceBox) {
          var current = priceBox.querySelector('[data-zh-current]');
          var compare = priceBox.querySelector('[data-zh-compare]');
          var discount = priceBox.querySelector('[data-zh-discount]');
          if (current) current.textContent = opt.getAttribute('data-price');
          if (compare) {
            if (compareRaw > priceRaw) {
              compare.textContent = opt.getAttribute('data-compare');
              compare.style.display = '';
              if (discount) { discount.textContent = '-' + Math.round((compareRaw - priceRaw) * 100 / compareRaw) + '%'; discount.style.display = ''; }
            } else {
              compare.style.display = 'none';
              if (discount) discount.style.display = 'none';
            }
          }
        }

        var skuEl = root.querySelector('[data-zh-sku]');
        if (skuEl && opt.getAttribute('data-sku')) { skuEl.textContent = opt.getAttribute('data-sku'); }

        var label = addBtn.querySelector('.add-label');
        if (opt.disabled) {
          addBtn.disabled = true;
          if (label) label.textContent = addBtn.getAttribute('data-drawer') ? 'Agotado' : 'Agotado';
        } else {
          addBtn.disabled = false;
          if (label) label.textContent = addBtn.getAttribute('data-drawer');
        }
      });
    }

    // Add to cart
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.getAttribute('data-variant');
        if (!variantId || variantId === '') {
          feedback.textContent = 'Producto no disponible.';
          feedback.classList.add('err');
          return;
        }
        var label = addBtn.querySelector('.add-label');
        var original = label ? label.textContent : '';
        addBtn.disabled = true;
        if (label) label.textContent = 'Añadiendo…';
        feedback.textContent = '';
        feedback.classList.remove('err');

        // Siempre suma a la cesta (si ya estaba, Shopify acumula la cantidad)
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: getQty() })
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e; });
          return res.json();
        })
        .then(function (data) {
          addBtn.disabled = false;
          if (label) label.textContent = original;
          // Cesta lateral (sections/zh-atc-popup.liquid)
          document.dispatchEvent(new CustomEvent('zh:cart-added', {
            detail: { item: data, variantId: variantId, quantity: getQty() }
          }));
          openDrawer();
        })
        .catch(function (err) {
          if (label) label.textContent = original;
          addBtn.disabled = false;
          feedback.textContent = (err && err.description) ? err.description : 'No se pudo añadir al carrito.';
          feedback.classList.add('err');
        });
      });
    }

    function openDrawer() {
      // Con la ventana «Añadido a la cesta» activa no se abre también el drawer
      if (window.ZHAtc && window.ZHAtc.enabled) { document.dispatchEvent(new CustomEvent('cart:refresh')); return; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (drawer) { drawer.classList.add('active', 'animate'); drawer.removeAttribute('inert'); return; }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    // Share
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({ url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            feedback.textContent = 'Enlace copiado.';
            feedback.classList.remove('err');
            setTimeout(function () { feedback.textContent = ''; }, 2000);
          });
        }
      });
    }

    // Sync active thumb on manual scroll
    if (main) {
      var scrollTimer;
      main.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = (main.scrollTop > main.scrollLeft)
            ? Math.round(main.scrollTop / main.clientHeight)
            : Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-zh-thumb') == idx);
          });
        }, 80);
      });
    }

    // === ZH-MGAL: indicador de progreso (solo móvil ≤749px) ===
    var zhProgress = root.querySelector('[data-zh-progress]');
    if (zhProgress && main && 'IntersectionObserver' in window) {
      var zhBars = zhProgress.querySelectorAll('.zh-mgal-bar');
      var zhSlides = main.querySelectorAll('[data-zh-slide]');
      var zhMq = window.matchMedia('(max-width: 749px)');
      var zhObserver = null;

      function zhSetActive(idx) {
        zhBars.forEach(function (b, i) {
          b.classList.toggle('is-active', i === idx);
        });
      }

      function zhStart() {
        if (zhObserver) return;
        zhObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              zhSetActive(parseInt(entry.target.getAttribute('data-zh-slide'), 10));
            }
          });
        }, { root: main, threshold: 0.6 });
        zhSlides.forEach(function (s) { zhObserver.observe(s); });
      }

      function zhStop() {
        if (!zhObserver) return;
        zhObserver.disconnect();
        zhObserver = null;
      }

      function zhHandleMq(e) { if (e.matches) zhStart(); else zhStop(); }
      zhHandleMq(zhMq);
      if (zhMq.addEventListener) { zhMq.addEventListener('change', zhHandleMq); }
      else { zhMq.addListener(zhHandleMq); }
    }

    // === ZH-DESK: alinear inicio de galería con la info (solo escritorio >990px) ===
    var zhGallery = root.querySelector('.zh-product-buy-gallery');
    if (zhGallery) {
      var zhDeskMq = window.matchMedia('(min-width: 991px)');
      var zhResizeTimer;

      function zhAlignGallery() {
        if (!zhDeskMq.matches) { zhGallery.style.top = ''; return; }
        zhGallery.style.position = 'static';
        var docTop = zhGallery.getBoundingClientRect().top + window.scrollY;
        zhGallery.style.position = '';
        var navEl = document.getElementById('sn-nav-wrap');
        var minTop = navEl ? navEl.offsetHeight + 16 : 100;
        zhGallery.style.top = Math.min(Math.round(docTop), minTop) + 'px';
      }

      zhAlignGallery();
      window.addEventListener('load', zhAlignGallery);
      window.addEventListener('resize', function () {
        clearTimeout(zhResizeTimer);
        zhResizeTimer = setTimeout(zhAlignGallery, 150);
      });
      if (zhDeskMq.addEventListener) { zhDeskMq.addEventListener('change', zhAlignGallery); }
      else { zhDeskMq.addListener(zhAlignGallery); }
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
